module.exports = __webpack_public_path__ + "assets/img/WechatIMG97.684204aa.png";